<template>
  <a-button class="my-button" :class="buttonClass" :type="newType">
    <template #icon>
      <slot name="icon">
        <!-- <SearchOutlined v-if="props.type=='search'" /> -->
        <!-- <sync-outlined v-if="props.type=='rest'" /> -->
        <plus-outlined v-if="props.type=='add'" />
        <redo-outlined v-if="props.type=='refresh'" />
      </slot>
    </template>
    <slot>{{ buttonTitle }}</slot>
  </a-button>
</template>

<script setup>
  import { ref, defineProps, computed } from 'vue';
  import { SearchOutlined, SyncOutlined, PlusOutlined,RedoOutlined } from '@ant-design/icons-vue';
  const props = defineProps({
    type: {
      type: String,
      default: 'primary'
    }
  });
  const buttonClass = ref('');
  const buttonTitle = ref('');
  const newType = computed(() => {
    if (['primary', 'ghost', 'dashed', 'link', 'text', 'default'].indexOf(props.type) != -1) {
      return props.type;
    }
    const customTypeIndex = ['add', 'delete', 'update', 'import', 'export', 'download', 'search', 'rest', 'preview', 'approval','refresh'].indexOf(props.type);//自定义类型
    if (customTypeIndex != -1) {
      buttonClass.value = props.type;
      buttonTitle.value = ['新增', '删除', '编辑', '导入', '导出', '下载', '搜索', '重置', '查看', '审批','刷新'][customTypeIndex];
      //console.log(buttonTitle.value,"buttonTitle.value");
      return 'default'
    }
    return 'primary'
  })
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-button {
    margin-right: 5px;
    border-radius: 4px;
    min-width: 88px;
    height: 36px;
  }
  .ant-btn-link {
    min-width: auto;
  }
  .add, .add:hover, .add:active, .add:focus {
    background-color: #2973FE;
    border-color: #2973FE;
    color: #fff;
  }

  .delete, .delete:hover, .delete:active, .delete:focus {
    background-color: #E6353B;
    border-color: #E6353B;
    color: #fff;
  }

  .update, .update:hover, .update:active, .update:focus {
    background-color: #2973FE;
    border-color: #2973FE;
    color: #fff;
  }

  .import, .import:hover, .import:active, .import:focus {
    background-color: #13ce66;
    border-color: #13ce66;
    color: #fff;
  }

  .export, .export:hover, .export:active, .export:focus {
    background-color: #ffba00;
    border-color: #ffba00;
    color: #fff;
  }

  .download, .download:hover, .download:active, .download:focus {
    background-color: #2973FE;
    border-color: #2973FE;
    color: #fff;
  }

  .search, .search:hover, .search:active, .search:focus {
    background-color: #2973FE;
    border-color: #2973FE;
    color: #fff;
  }
  .preview, .preview:hover, .preview:active, .preview:focus {
    background-color: #2973FE;
    border-color: #2973FE;
    color: #fff;
  }
  .approval, .approval:hover, .approval:active, .approval:focus {
    background-color: #ff9900;
    border-color: #ff9900;
    color: #fff;
  }
  .add:hover,
  .delete:hover,
  .update:hover,
  .import:hover,
  .export:hover,
  .download:hover,
  .search:hover
  .add:focus,
  .delete:focus,
  .update:focus,
  .import:focus,
  .export:focus,
  .download:focus,
  .search:focus
  .preview:focus
  .approval:focus {
    opacity: 0.7;
  }
</style>
